import Axios from 'axios';

export default {
  getStates() {
    return Axios.get('/states');
  },

  getCities(stateId) {
    return Axios.get('/cities', {
      params: {
        state_id: stateId,
      },
    });
  },
};
